import React, { useEffect } from 'react';
import { Link, RouteComponentProps } from 'react-router-dom';
import { Button, Row, Col } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { getEntity } from './met-scholarship.reducer';
import { APP_DATE_FORMAT, APP_LOCAL_DATE_FORMAT } from 'app/config/constants';
import { useAppDispatch, useAppSelector } from 'app/config/store';

export const MetScholarshipDetail = (props: RouteComponentProps<{ id: string }>) => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(getEntity(props.match.params.id));
  }, []);

  const metScholarshipEntity = useAppSelector(state => state.metScholarship.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="metScholarshipDetailsHeading">
          <Translate contentKey="almobadaraMasterDataApp.metScholarship.detail.title">MetScholarship</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="global.field.id">ID</Translate>
            </span>
          </dt>
          <dd>{metScholarshipEntity.id}</dd>
          <dt>
            <span id="code">
              <Translate contentKey="almobadaraMasterDataApp.metScholarship.code">Code</Translate>
            </span>
          </dt>
          <dd>{metScholarshipEntity.code}</dd>
          <dt>
            <span id="name">
              <Translate contentKey="almobadaraMasterDataApp.metScholarship.name">Name</Translate>
            </span>
          </dt>
          <dd>{metScholarshipEntity.name}</dd>
          <dt>
            <span id="nameAr">
              <Translate contentKey="almobadaraMasterDataApp.metScholarship.nameAr">nameAr</Translate>
            </span>
          </dt>
          <dd>{metScholarshipEntity.nameAr}</dd>
          <dt>
            <span id="nameEn">
              <Translate contentKey="almobadaraMasterDataApp.metScholarship.nameEn">nameEn</Translate>
            </span>
          </dt>
          <dd>{metScholarshipEntity.nameEn}</dd>
          <dt>
            <span id="status">
              <Translate contentKey="almobadaraMasterDataApp.metScholarship.status">Status</Translate>
            </span>
          </dt>
          <dd>{metScholarshipEntity.status}</dd>
        </dl>
        <Button tag={Link} to="/met-scholarship" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/met-scholarship/${metScholarshipEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default MetScholarshipDetail;
